module.exports = __webpack_public_path__ + "media/images/lb/909-c97931079325ec4ce2f5783b2469be0d.svg";